var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoVer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_427319075",
    "data-name": "Group 427319075",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_427319074",
    "data-name": "Group 427319074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.8,3.48A9.77,9.77,0,0,0,2.18,7.5a9.822,9.822,0,0,0,17.64,0A9.841,9.841,0,0,0,5.8,3.48ZM22,7.5a11.817,11.817,0,0,1-22,0,11.817,11.817,0,0,1,22,0ZM9.232,5.732A2.5,2.5,0,1,0,11,5,2.5,2.5,0,0,0,9.232,5.732ZM15.5,7.5A4.5,4.5,0,1,1,11,3,4.507,4.507,0,0,1,15.5,7.5Z",
    fill: "#2fb7cf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoVer);
export default __webpack_public_path__ + "static/media/icono-ver.2d4180e4cfd70e947b5dca5bd7a3560e.svg";
export { ForwardRef as ReactComponent };